export const thisHost = window.location.protocol.concat("//").concat(window.location.host);
export const homePage = `${thisHost}/`;
export const theCurb = `${thisHost}/curb`;